import axios from "axios";
import { REACT_APP_MAP_APIS_BASEURL } from "../values/constants";

export default axios.create({
    baseURL: REACT_APP_MAP_APIS_BASEURL,
    headers: {
        'Content-Type': 'application/json',
    }
});